var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewStructureIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11.2,
    viewBox: "0 0 16 11.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-friends",
    "data-name": "Icon awesome-user-friends",
    d: "M4.8,7.85A2.8,2.8,0,1,0,2,5.05,2.8,2.8,0,0,0,4.8,7.85Zm1.92.8H6.513a3.866,3.866,0,0,1-3.425,0H2.88A2.881,2.881,0,0,0,0,11.53v.72a1.2,1.2,0,0,0,1.2,1.2H8.4a1.2,1.2,0,0,0,1.2-1.2v-.72A2.881,2.881,0,0,0,6.72,8.65ZM12,7.85a2.4,2.4,0,1,0-2.4-2.4A2.4,2.4,0,0,0,12,7.85Zm1.2.8h-.1a3.153,3.153,0,0,1-2.21,0H10.8a2.777,2.777,0,0,0-1.393.385,3.659,3.659,0,0,1,.993,2.5v.96c0,.055-.012.108-.015.16H14.8a1.2,1.2,0,0,0,1.2-1.2A2.8,2.8,0,0,0,13.2,8.65Z",
    transform: "translate(0 -2.25)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewStructureIco);
export default __webpack_public_path__ + "static/media/new-structure-ico.72e4dc53.svg";
export { ForwardRef as ReactComponent };